module.exports = "<div ng-repeat=\"msg in $ctrl.decodedMsg track by $index\">\n  <p> {{msg}} </p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/input-screen/comment-box/probability-form/probability-form.display.html
// module id = 608
// module chunks = 0